const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'staging';
// eslint-disable-next-line no-underscore-dangle
const runtime = (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) || {};

const getConfig = () => {
  // switch (ENV) {
  //   case 'prod':
  //     return {
  //       api: {
  //         elkUrl: 'https://ch-prod.es.us-east-2.aws.elastic-cloud.com/prod_',
  //         baseUrl: 'https://web.confidanthealth.com/api/rest',
  //         socketClientUrl: 'wss://prod2-chat.confidantdemos.com/',
  //         oneSignalAppId: '6b0fc72c-d9a7-41bc-8342-56a25e05b24c',
  //         timeout: 60000,
  //         GC_WEBAPP_AUTH_ID: '437840869953-ae48s7f0nekp7ln4pdrd5ft1m947p99b.apps.googleusercontent.com',
  //       },
  //       memberAppUrl: 'https://member.confidanthealth.com/',
  //       sendbird: {
  //         appId: '66F019F3-8A15-4988-AD9F-49376CFB9CEF', // Prod Sendbird App ID
  //       },
  //       twilio: {
  //         phoneNumber: '+15127686086',
  //       },
  //       opentok: {
  //         apiKey: '46695512',
  //       },
  //     };
  //   case 'qa':
  //     return {
  //       api: {
  //         elkUrl: 'https://elastic-staging.confidanthealth.com/qa_',
  //         baseUrl: 'https://qa.confidantdemos.com/rest',
  //         socketClientUrl: 'wss://qa-chat.confidantdemos.com/',
  //         oneSignalAppId: '660a6f2d-471a-40f8-9ad0-a0a16f99eebb',
  //         timeout: 60000,
  //         GC_WEBAPP_AUTH_ID: '165839181374-v6ubh1t138cptthemoe12l31u663g6eq.apps.googleusercontent.com',
  //       },
  //       memberAppUrl: 'https://member-m.qa.confidanthealth.com/',
  //       sendbird: {
  //         appId: '5107E113-620A-4449-BB78-81A731FEB602', // QA sendbird App Id
  //       },
  //       twilio: {
  //         phoneNumber: '+18044557679',
  //       },
  //       opentok: {
  //         apiKey: '46419812',
  //       },
  //     };
  //   case 'local':
  //     return {
  //       api: {
  //         elkUrl: 'https://elastic-staging.confidanthealth.com/sit1',
  //         baseUrl: 'http://localhost:[port]',
  //         socketClientUrl: 'wss://qa-chat.confidantdemos.com/',
  //         oneSignalAppId: '660a6f2d-471a-40f8-9ad0-a0a16f99eebb',
  //         GC_WEBAPP_AUTH_ID: '165839181374-v6ubh1t138cptthemoe12l31u663g6eq.apps.googleusercontent.com',
  //         timeout: 60000,
  //       },
  //       memberAppUrl: 'https://member-m.qa.confidanthealth.com/',
  //       sendbird: {
  //         appId: '5107E113-620A-4449-BB78-81A731FEB602', // QA sendbird App Id
  //       },
  //       twilio: {
  //         phoneNumber: '+18044557679',
  //       },
  //       opentok: {
  //         apiKey: '46419812',
  //       },
  //     };
  //   case 'sit1':
  //     return {
  //       api: {
  //         elkUrl: 'https://elastic-staging.confidanthealth.com/sit1',
  //         baseUrl: 'https://sit1.confidantdemos.com/rest', // 'https://sit1.confidantdemos.com/rest',
  //         socketClientUrl: 'wss://sit1-chat.confidantdemos.com/',
  //         oneSignalAppId: '660a6f2d-471a-40f8-9ad0-a0a16f99eebb',
  //         GC_WEBAPP_AUTH_ID: '165839181374-v6ubh1t138cptthemoe12l31u663g6eq.apps.googleusercontent.com',
  //         timeout: 60000,
  //       },
  //       memberAppUrl: 'https://member-m.sit1.confidanthealth.com/',
  //       sendbird: {
  //         appId: '41FCE9D5-9B0D-43F2-9B00-46D7F5F7C99C', // SIT1 Sendbird App ID
  //       },
  //       twilio: {
  //         phoneNumber: '+18044557679',
  //       },
  //       opentok: {
  //         apiKey: '46419812',
  //       },
  //     };
  //   default:
  //     throw Error(`Unconfigured environment '${ENV}'. Can be configured in src/config.js.`);
  // }
  return {
    api: {
      elkUrl: runtime.VITE_ELK_URL ?? process.env.VITE_ELK_URL,
      baseUrl: runtime.VITE_BASE_URL ?? process.env.VITE_BASE_URL,
      socketClientUrl: runtime.VITE_SOCKET_CLIENT_URL ?? process.env.VITE_SOCKET_CLIENT_URL,
      oneSignalAppId: runtime.VITE_ONE_SIGNAL_APP_ID ?? process.env.VITE_ONE_SIGNAL_APP_ID,
      timeout: runtime.VITE_TIMEOUT ?? process.env.VITE_TIMEOUT,
      GC_WEBAPP_AUTH_ID: runtime.VITE_GC_WEBAPP_AUTH_ID ?? process.env.VITE_GC_WEBAPP_AUTH_ID,
    },
    memberAppUrl: runtime.VITE_MEMBER_APP_URL ?? process.env.VITE_MEMBER_APP_URL,
    sendbird: {
      appId: runtime.VITE_SENDBIRD_APP_ID ?? process.env.VITE_SENDBIRD_APP_ID,
    },
    twilio: {
      phoneNumber: runtime.VITE_TWILIO_PHONE_NUMBER ?? process.env.VITE_TWILIO_PHONE_NUMBER,
    },
    opentok: {
      apiKey: runtime.VITE_OPENTOK_API_KEY ?? process.env.VITE_OPENTOK_API_KEY,
    },
  };
};

export default getConfig();
